import { FormControl, Grid, TextareaAutosize } from '@mui/material';
import Panel from '../../../components/UI/Panel';

export default function FacilityNotesInfo({
  formik,
  showPanel,
}: {
  formik: any;
  showPanel: boolean;
}) {
  const content = (
    <Grid container spacing={2} mx={1} px={1}>

      <Grid my={2} container>
        <Grid item xs={12} px={2}>
          <FormControl fullWidth>
            <TextareaAutosize
              id="notes"
              name="notes"
              minRows={4}
              maxRows={6}
              placeholder="Notes"
              value={formik.values.notes}
              onChange={(e: any) => {
                formik.setFieldValue('notes', e.target.value);
              }}
              onBlur={(e) => {
                e.target.style.border = '1px solid #ccc';
                formik.setFieldTouched('notes', true);
              }}
              onFocus={(e) => {
                e.target.style.border = '2px solid #F97316';
              }}
              style={{
                width: '66%',
                padding: '8px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                resize: 'none',
                fontFamily: '"Arial", "Helvetica", sans-serif',
                outline: 'none',
                boxSizing: 'border-box',
                fontSize: '14px'
              }}              
            />
          </FormControl>
        </Grid>
      </Grid>
    </Grid>
  );
  return (
    <>
      {showPanel === true && (
        <Panel headerText="Notes">{content}</Panel>
      )}
      {!showPanel && content}
    </>
  );
}

FacilityNotesInfo.defaultProps = {
  showPanel: true,
};
